import { WorkFlowBatchInfo } from './work-flow-batch-info.model';
export class WorkFlowBatchSignRequest {
  token?: string;
  userId?: number;
  workFlowBatchInfos?: Array<WorkFlowBatchInfo>;
}
